import {AccidentsGroup} from '@/read-model/AccidentsGroup';
import {Accident} from "../read-model/accident";
import {Location} from "../read-model/Location";
import {RawAccident} from './RawAccident';

const reader = require('g-sheets-api');

export function createAccident(rawAccident: RawAccident): Accident {
  const rawLocation = rawAccident.geo.trim().split(',')
  const latittude = parseFloat(rawLocation[0].trim())
  const longitude = parseFloat(rawLocation[1].trim())
  const dead: number = parseInt(rawAccident.ofiary)
  const wounded: number = parseInt(rawAccident.ranni)
  const links: Array<string> = [rawAccident["link 1"]]

  if (typeof rawAccident["link 2"] === "string" && rawAccident["link 2"] !== "") {
    links.push(rawAccident["link 2"])
  }

  if (typeof rawAccident["link 3"] === "string" && rawAccident["link 3"] !== "") {
    links.push(rawAccident["link 3"])
  }

  return new Accident(
    rawAccident.nazwa,
    rawAccident.opis,
    new Date(rawAccident.data),
    rawAccident.dzielnica,
    rawAccident.miejsce,
    new Location(
      latittude,
      longitude,
    ),
    dead,
    wounded,
    links,
    rawAccident.obraz,
    (rawAccident.zniszczenia ?? "")
      .split(",")
      .map((damage: string): string => damage.trim())
      .filter((damage: string): boolean => damage !== "")
  )
}

export function createAccidents(results: Array<RawAccident>): Accident[] {
  return results
    .filter(rawAccident => rawAccident.geo != undefined)
    .filter(rawAccident => rawAccident.ranni != undefined)
    .filter(rawAccident => rawAccident.ofiary != undefined)
    .filter(rawAccident => rawAccident.geo.indexOf(',') !== -1)
    .map(createAccident);
}

export function groupAccidents(accidents: Array<Accident>): Array<AccidentsGroup> {
  const groups = new Array<AccidentsGroup>()
  for (const accident of accidents) {
    const found = groups.find((group) => group.belongs(accident))
    if (found == undefined) {
      groups.push(new AccidentsGroup([accident]))
    } else {
      found.add(accident)
    }
  }
  return groups
}

export type AccidentsGroupsLoader = () => Promise<AccidentsGroup[]>
export type AccidentsLoader = () => Promise<Accident[]>

type AnyObject = { [key: string]: any };
const lowercaseKeys = (obj: AnyObject, deep = false) =>
    Object.keys(obj).reduce((acc, key) => {
      acc[key.toLowerCase()] =
          deep && typeof obj[key] === "object" ? lowercaseKeys(obj[key]) : obj[key];
      return acc;
    }, {} as AnyObject);

export async function accidents(): Promise<Accident[]> {
  return new Promise((resolve) => {
    // @ts-ignore
    const isCypress = typeof window !== "undefined" && window?.Cypress
    const sheetId = process.env["SHEET_ID"]
      ?? (process.env["NODE_ENV"] === "development" || isCypress ? "1SVg9bp0o69KD6UxO8tCfoaEQ5tsU8M94k8wvuudLu8o" : null)
      ?? "1Yoc7NKoDqcMzcmbFyOVj8Lmx96TYlPEsI__aG7jifwM";

    try {
      reader(
          {
            apiKey: 'AIzaSyCnlt696OlYXmYlR-ROpQEtPk4B33C_qJQ',
            sheetId,
            returnAllResults: false,
            sheetName: 'Warszawa',
          }, (results: Array<RawAccident>) => {
            console.log((results));
            resolve(createAccidents(results.map(a => lowercaseKeys(a) as RawAccident)));
          }
      );
    } catch (e) {
      console.error(e);
    }
  })
}
